import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function dm_a_va_01_search_jobs_cta() {
    
const layers = document.querySelectorAll(".floating-image");

layers.forEach((layer) => {
    const speed = parseFloat(layer.dataset.scrollRate) || 0;

    gsap.to(layer, {
        y: speed * 200,
        ease: "none",
        scrollTrigger: {
            trigger: ".a-va-01-search-jobs-cta",
            start: "top top",
            end: "bottom top",
            scrub: true,
        },
    });
});

}


export { dm_a_va_01_search_jobs_cta };